import { observer } from 'mobx-react-lite'
import React from 'react'
import CardsGrid from './CardsGrid/CardsGrid'
import TableView from './TableView/TableView'
import SaveListNameModal from './SaveListNameModal/SaveListNameModal'
import { useViewStudents } from './hooks/useViewStudents'
import s from './styles/ViewStudents.module.scss'

import { SelectionBar } from '../../../shared/components/SelectionBar/SelectionBar'

const ViewStudents = observer(
	({
		onOpenSendMessage,
		onOpenAssignActivity,
		// onOpenBookSession,
		isOpenFilter,
		onSortChange,
		isLoading = false,
	}) => {
		const {
			view,
			students,
			selectedIds,
			allSelected,
			hasSelection,
			selectionText,
			handleToggleOne,
			handleToggleAll,
			handleClearSelection,
			sortKey,
			sortDir,
			handleSort,
			acceptNameHandler,
			isOpenModalNameList,
			setIsOpenModalNameList,
			nameList,
			changeNameListHandler,
			defaultNamberList,
			errNameList,
			actions,
		} = useViewStudents({
			onOpenSendMessage,
			onOpenAssignActivity,
			// onOpenBookSession,
		})

		const viewContent =
			view === 'card' ? (
				<CardsGrid
					students={students}
					selectedIds={selectedIds}
					onToggleOne={handleToggleOne}
				/>
			) : (
				<TableView
					students={students}
					selectedIds={selectedIds}
					allSelected={allSelected}
					onToggleAll={handleToggleAll}
					onToggleOne={handleToggleOne}
					sortKey={sortKey}
					sortDir={sortDir}
					onSort={handleSort}
					onSortChange={onSortChange}
					isOpenFilter={isOpenFilter}
					hasSelection={hasSelection}
					isLoading={isLoading}
				/>
			)

		return (
			<div className={s.wrap}>
				<SelectionBar
					isVisible={hasSelection}
					isOffset={isOpenFilter}
					text={selectionText}
					onClear={handleClearSelection}
					onClose={handleClearSelection}
					actions={actions}
					className={s.selectionBar}
				/>

				<SaveListNameModal
					isOpen={isOpenModalNameList}
					onClose={() => setIsOpenModalNameList(false)}
					value={nameList}
					onChange={changeNameListHandler}
					onSubmit={() => acceptNameHandler(nameList)}
					defaultPlaceholder={`My List ${defaultNamberList}`}
					errNameList={errNameList}
				/>

				<div className={`${s.content} ${isOpenFilter ? s.open : ''}`.trim()}>
					{viewContent}
				</div>
			</div>
		)
	},
)

export default ViewStudents
